module.exports = __webpack_public_path__ + "img/category-title02-m.4e1a185a.png";